import React from 'react';
import { HeroSection }    from '../sections/home/HeroSection';
import { TrustBadgeRow }  from '../sections/home/TrustBadgeRow';
import { CategoryGrid }   from '../sections/home/CategoryGrid';
import { WhySection }     from '../sections/home/WhySection';
import { ProductGrid }    from '../sections/home/ProductGrid';
import { StepsSection }   from '../sections/home/StepsSection';
import { CTASection }     from '../sections/home/CTASection';

const Home: React.FC = () => (
  <>
    <HeroSection />
    <TrustBadgeRow />
    <CategoryGrid />
    <WhySection />
    <ProductGrid limit={4} />
    <StepsSection />
    <CTASection />
  </>
);

export default Home;
